import 'jquery';
import ds from 'Shared/ds';
import modal from 'Shared/modal';

class DocumentApi {

    static show = (docType, docId) => {
        var url = this.#const.SHOW_DOCUMENT + docId + "/" + docType;

        return ds.get(url)
            .done(result => {
                if (result.url) {
                    window.open(result.url, '_blank');
                }
                else {
                    modal.open(result);
                }
            });
    }

    static #const = {
        SHOW_DOCUMENT: "/documents/"
    };
}

export default DocumentApi;
      
    

    

  